import { render, staticRenderFns } from "./CollectionPageEM.vue?vue&type=template&id=373fd306"
import script from "./CollectionPageEM.vue?vue&type=script&lang=js"
export * from "./CollectionPageEM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports